import { Card } from "antd";

const AdsCheckoutCard = ({ data, name }) => {
  return (
    <Card className="m-2 shadow-md">
      <div className="flex justify-between mx-3">
        <div>
          <p className="text-primaryPurple font-bold text-lg">Summary</p>
          <p className="font-medium">{`${data?.advertisementTypeId?.name}, ${data?.city}, ${data?.state}`}</p>
        </div>
        <div>
          <p className="text-primaryPurple  font-bold text-lg">
            Total Price to be Paid
          </p>
          <p className="text-primaryOrange">${data?.numberOfDays * 10}</p>
        </div>
      </div>
    </Card>
  );
};
export default AdsCheckoutCard;
